import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { ApplicationData } from "../ApplicationData";
import { AvailabilityClientManager } from "../ClientManagers/AvailabilityClientManager";

export class CopiesControl {
  constructor(options) {
    //TODO default action option = action
    this.id = options.id;
    this.tmpl = "tmpl/controls/Copies/CopyControl.html";
    this.tmpl_serial = "tmpl/controls/Copies/CopyControl_Serial.html";
    this.holdings = null;
    this.action = options.action !== undefined ? options.action : "";
    //todo delegate root option
  }
  loadHoldings(resourceId, holdingsToChunk, callback) {
    var holdingsInformations = holdingsToChunk,
      _this = this,
      holdingsChunck;
    if (
      holdingsInformations === undefined ||
      holdingsInformations.length === 0
    ) {
      callback();
      return;
    }
    if (holdingsInformations.length > 300) {
      holdingsChunck = holdingsInformations.splice(0, 300);
    } else if (holdingsInformations.length > 0) {
      holdingsChunck = holdingsInformations.splice(
        0,
        holdingsInformations.length
      );
    }
    AvailabilityClientManager.getItemAvailabilityByHoldings(
      holdingsChunck,
      resourceId,
      function (resources, wentToServer, success) {
        _this.holdings.push.apply(_this.holdings, holdingsChunck);
        _this.loadHoldings(resourceId, holdingsToChunk, callback);
      },
      false,
      false
    );
  }
  render(resource, callback) {
    var _this = this;
    this.holdings = [];
    this.collectionOfBranches = [];
    var template = resource.serial ? _this.tmpl_serial : _this.tmpl;
    var copyOfHoldings = resource.holdingsInformations.slice();
    var numberOfUnfilteredHoldings = copyOfHoldings.length;

    if (
      resource.serial &&
      !ApplicationData.locationConfiguration.getAllowHolds().onShelf
    ) {
      // Exclude items that are available at the user's branch
      var availabilityBranch = ApplicationData.getBranchToUseForAvailability();
      copyOfHoldings = this.filterHoldings(copyOfHoldings, availabilityBranch);
    }

    if (copyOfHoldings.length < numberOfUnfilteredHoldings) {
      $("#placeHoldOnShelfInfoMessage").show();
    }

    this.loadHoldings(resource.id, copyOfHoldings, function () {
      $("#" + _this.id).hide();
      _this.separateBranchData(_this.holdings, _this.collectionOfBranches);
      resource.collectionOfBranches = _this.collectionOfBranches;

      $.each(_this.collectionOfBranches, function (i, branchItem) {
        TemplateEngine.fetch(
          template,
          _this.id,
          {
            branch: branchItem.branch,
            holdings: branchItem.holdings,
            action: _this.action,
          },
          function () {
            if (callback) callback();
          }
        );
      });
    });
  }
  filterHoldings(unfilteredHoldings, branch) {
    return unfilteredHoldings.filter(function (holding) {
      return (
        !holding.available ||
        (holding.available && holding.branchIdentifier != branch)
      );
    }, this);
  }
  onChange(callback, rootSelector) {
    if (rootSelector === undefined) {
      rootSelector = $("body");
    }
    rootSelector.on(
      "change",
      "#" + this.id + " .requestCopyCheckbox",
      function (event) {
        if (callback) {
          callback(event.currentTarget, event);
        }
      }
    );
  }
  disable() {
    if ($("#" + this.id).is(":visible")) {
      $("#" + this.id).hide();
    }
  }
  enable() {
    if ($("#" + this.id).is(":hidden")) {
      $("#" + this.id).show();
    }
  }
  setDefaultSelection() {}
  getCurrentSelection() {
    var checkedCopies = $("#" + this.id).find(".requestCopyCheckbox:checked"),
      currentSelection = [],
      _this = this;
    $.each(checkedCopies, function (i, checkedCopy) {
      var barcode = checkedCopy.value;
      currentSelection.push(
        $.grep(_this.holdings, function (b) {
          return b.barcode === barcode;
        })[0]
      );
    });
    return currentSelection;
  }
  setCurrentSelection(value) {}
  addEvents() {}
  separateBranchData(holdings, collectionOfBranches) {
    var branchItem = {};
    var branchIds = ApplicationData.branchLimitsUtil.getDisplayInCopiesIds();
    var _this = this;

    holdings = $.grep(holdings, function (result) {
      return $.inArray(result.branchIdentifier, branchIds) != -1;
    });

    $.each(holdings, function (index, holding) {
      branchItem = _this.getBranchItemFromHolding(
        holding,
        collectionOfBranches
      );
      branchItem.holdings.push(holding);
    });

    //now sort the branches into alpha order
    collectionOfBranches.sort(function (lhs, rhs) {
      if (lhs.branch.toLowerCase() > rhs.branch.toLowerCase()) {
        return 1;
      } else if (lhs.branch.toLowerCase() < rhs.branch.toLowerCase()) {
        return -1;
      }
      return 0;
    });

    // sort descending by chronology+enumeration
    $.each(collectionOfBranches, function (index, branch) {
      branch.holdings.sort(function (lhs, rhs) {
        var leftSort = lhs.chronologySort + lhs.enumerationSort;
        var rightSort = rhs.chronologySort + rhs.enumerationSort;
        if (leftSort < rightSort) {
          return 1;
        } else if (leftSort > rightSort) {
          return -1;
        }
        return 0;
      });
    });
  }
  getBranchItemFromHolding(holding, collectionOfBranches) {
    for (var x = 0; x < collectionOfBranches.length; x++) {
      if (collectionOfBranches[x].branch === holding.branchName) {
        return collectionOfBranches[x];
      }
    }

    var branchItem = {};
    branchItem.branch = holding.branchName;
    branchItem.tableID = "copiesTable_" + holding.branchIdentifier;
    branchItem.holdings = [];
    branchItem.callout = "";
    branchItem.showLink = false;
    collectionOfBranches.push(branchItem);
    return branchItem;
  }
}
